<template>
  <div v-if="authenticatedUser">
    <b-container>
      <div class="mt-5 mb-3 ml-0 mr-0 ">
        <b-card no-body>
          <b-card-header header-tag="nav">
            <b-row>
              <b-col class="col-9">
                <b-nav
                  card-header
                  pills
                >
                  <b-nav-item @click="showMyOrganisations" :class="selector ? 'active' : ''">
                    Organisations I've added
                  </b-nav-item>
                  <b-nav-item @click="showPublicOrganisations" :class="!selector ? 'active' : ''">
                    All Organisations
                  </b-nav-item>
                </b-nav>
              </b-col>
              <b-col class="col-3">
                <span class="float-right mt-1">
                  <router-link
                    :to="{name: 'organizationAdd'}"
                    class="btn-create"
                  >
                    <img
                      height="32"
                      src="/static/img/ic-feature-create.png"
                    />
                    <span>Add organisation</span>
                  </router-link>
                </span>
              </b-col>
            </b-row>
<!--        <b-nav v-show="!selector" card-header tabs fill>-->
<!--          <b-nav-item @click="showMyOrganisations">Organisations I've added</b-nav-item>-->
<!--          <b-nav-item @click="showPublicOrganisations" active>Public</b-nav-item>-->
<!--          <b-nav-item class="text-right text-white">-->
<!--            <router-link class="btn btn-sm bg-orange pb-0 pt-0" :to="{name: 'organizationAdd'}">Add organisation</router-link>-->
<!--          </b-nav-item>-->
<!--        </b-nav>-->
          </b-card-header>
          <hr>
          <b-card-body class="text-center">
            <!-- Own Organizations -->
            <OrganizationSection v-show="selector" id="my-organizations" :type="ownOrganizations"/>
            <!-- Public Organizations -->
            <OrganizationSection v-show="!selector" id="public-organizations" class="mb-3" :type="publicOrganizations"/>
          </b-card-body>
        </b-card>
      </div>
    </b-container>
  </div>
  <div v-else>
    <NoAccess></NoAccess>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OrganizationSection from '../components/organizations/OrganizationSection'
import NoAccess from '../components/NoAccess'

export default {
  name: 'Organizations',
  data () {
    return {
      selector: true,
      'publicOrganizations': 'PUBLIC',
      'ownOrganizations': 'OWN'
      // 'sharedOrganizations': 'SHARE'
    }
  },
  components: {
    OrganizationSection,
    NoAccess
  },
  computed: {
    ...mapGetters([
      'authenticatedUser'
    ])
  },
  methods: {
    showMyOrganisations () {
      this.selector = true
    },
    showPublicOrganisations () {
      this.selector = false
    }
  }
}
</script>

<style scoped>
  hr {
    margin: 0 20px 0 20px;
  }

  .card-header {
    background-color: #fff;
    padding: 20px 30px 16px 30px;
    border: 0;
  }

  .nav.nav-pills {
    height: 38px;
  }

  .nav-item {
    height: inherit;
    margin-right: 8px;
    background-color: #545b62;
    border-color: #545b62;
    border-radius: 5px;
  }
  .nav-item.active {
    background-color: #EE861D;
    border-color: #EE861D;
  }

  .nav-link {
    height: inherit;
    line-height: 22px;
    text-align: center;
    width:200px;
    color: #fff;
  }

  .btn-create {
    font-size: 14pt;
  }
  .btn-create:hover {
    text-decoration: none;
    padding-right: 6px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Organizations.vue